@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.distributionRow {
  display: flex;
  align-items: center;
  padding: 8px 0;
  gap: 8px;
  width: 100%;

  .label {
    width: 120px;
    max-width: 120px;
    flex: 0 1 120px; // Allow shrinking but not growing
    color: var(--dark-80);
    font-size: 14px;
    @include line-clamp(1);
  }

  .barContainer {
    flex: 1;
    position: relative;
  }

  .bar {
    position: relative;
    height: 12px;
    background-color: var(--dark-4);
    border-radius: 4px;
    overflow: hidden;

    .fill {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background-color: #0077ff;
      border-radius: 4px;
      transition: width 0.3s ease;
    }
  }

  .percentage {
    width: 50px;
    flex: 0 0 50px;
    text-align: right;
    color: var(--dark-60);
    font-size: 14px;
  }
}

.loadingContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 175px;
}

.errorContainer {
  width: 100%;
  height: 175px;
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
